import React from "react";
import styled from "styled-components";

const Burguer = () => {
  return (
    <Container>
        <Span></Span>
        <Span></Span>
        <Span></Span>
    </Container>
  );
};

const Container = styled.div`
    @media(min-width: 768px){
        display: none;
    }
    cursor: pointer;
`;

const Span = styled.span`
    background: white;
    display: block;
    width: 40px;
    height: 05px;
    border-radius: .2rem;
    margin-top: 5px;
`;


export default Burguer;